'use strict'

exports = module.exports = require('../commonjs/react/Input.js').default

exports['default'] = require('../commonjs/react/Input.js').default